/* global translate */
import React from 'react';
import './index.css';

import subDays from "date-fns/subDays";
import DatePicker from "react-datepicker";
import "./react-datepicker-choose.css";

const AddMemberCalendar = require('./AddMember').default

const { rxgetLocal } = global.rootRequire('classes/request')
const { rxaget, rxChangeSlug } = global.rootRequire('classes/ulti')
const { changeColorAva, textAva } = global.rootRequire('classes/chat')

const days = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7']
const daysEngStr = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
const arrDays = ['Chủ Nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7']

const months = ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12']
const monthsEng = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

const locale = {
  localize: {
    day: n => days[n],
    month: n => months[n]
  },
  formatLong: {
    date: () => 'mm/dd/yyyy',
    time: () => 'HH:mm'
  }
}

export function subString(str, pos) {
  pos = pos || 33
  let result = ''
  if (str && typeof (str) === 'string' && str.length > pos) {
    result = str.substr(0, pos) + ' ...'
  } else {
    result = str
  }

  return result
}


export function convertUnixToDateTime(UNIX_timestamp, type, lang) {
  var date = new Date(UNIX_timestamp * 1000)

  var year = date.getFullYear()
  var month = ("0" + (Number(date.getMonth()) + 1)).substr(-2)
  var day = ("0" + date.getDate()).substr(-2)
  var hour = ("0" + date.getHours()).substr(-2)
  var minutes = ("0" + date.getMinutes()).substr(-2)

  if (type === 'hour') {
    return hour + ':' + minutes
  } else if (type === 'date') {
    return day + '/' + month + '/' + year
  } else if (type === 'custom') {
    // if (lang === 'en') {
    //   return daysEngStr[date.getDay()] + ', ' + day + ' ' + monthsEng[date.getMonth()] + ' ' +  hour + ':' + minutes
    // } else {
    //   return arrDays[date.getDay()] + ', ' + day + ' ' + months[date.getMonth()] + ' lúc ' + hour + ':' + minutes
    // }
    return  hour + ':' + minutes + ' ' + day + '/' + month + '/' + year
    
  } else {
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes
  }
}



// Create component class for calendar
class DetailCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: props.detail,
      flagPopupOptionCalendar: false,
      flagPopupConfirm: false,
      flagAuthOwner: false,
      flagShowRecipients: false,
      flagNoteDescCalendar: false
    }

    let netaAuthUser =  global.rxu.json(rxgetLocal('rxuserneta'), { user:{} })
    this.userOwner = {}
    let recipients = rxaget(props.detail, 'recipients', [])
    let userCurrent = rxaget(netaAuthUser, 'user.phone', '')
    if (recipients && recipients.constructor === Array && recipients.length > 0) {
      let findUser = recipients.find(u => u.owner === true)
      this.userOwner = findUser
      if (findUser && findUser.username === userCurrent) {
        this.state.flagAuthOwner = true
      }
    }

    let language = localStorage.getItem('netaLang') || 'vi'
    this.language = language.replace(/"/g, '')
    this.locale =  locale
    if (language.indexOf('en') !== -1) {
      this.locale = 'en'
    }
  }

 
  handleClickOutside(e) {
    if (e.target.className === 'zchat_choose_calendar-bg') {
      this.setState({
        flagPopupOptionCalendar: false,
        flagShowRecipients: false,
        flagNoteDescCalendar: false
      })
    } else {
      this.setState({
        flagNoteDescCalendar: false
      })
    }
  }

  showPopupOptionCalendar() {
    this.setState({
      flagPopupOptionCalendar: true
    })
  }

  cancelDescConfirm() {
    this.setState({
      flagPopupConfirm: false,
      flagPopupOptionCalendar: false
    })
  }

  confirmDelete() {
    let detail = this.state.detail
    let base_api_neta = global.rxu.config.base_api_neta
    let calendar_link = base_api_neta + '/api/calendar/delete'

    let headers = {'Content-Type': 'application/json'}

    let data = {
      id: detail.id
    }
   
    let netaAuthUser =  global.rxu.json(rxgetLocal('rxuserneta'), { user:{} })
    if (rxaget(netaAuthUser, 'user.token', '')) {
      // data['tc_token'] = '01629d751aa0fbf347e9be116b2d9e239423vTjf'//rxaget(netaAuthUser, 'user.token', '')
    }

    headers['TC-Token'] = rxaget(netaAuthUser, 'user.token', '')
    
   
    fetch(calendar_link, { 
      method: 'DELETE', 
      headers: headers,
      body: JSON.stringify(data)
    }).then( res => res.json()).then((json) => {
      if (json && json.message === "success") {
        this.props.backFuncDel(detail)
      } else {
        // alert("Delete Calendar Not Success")
      }
    })
  }

  chooseOptionCalendar(type) {
    if (type === 'delete') {
      this.setState({
        flagPopupConfirm: true
      })
    }

    if (type === 'edit') {
      this.props.editCalendarFunc()
    }

    this.setState({
      flagPopupOptionCalendar: false
    })
  }

  showRecipients() {
    // let flagShowRecipients = this.state.flagShowRecipients
    this.setState({
      flagShowRecipients: true
    })
  }

  showPopupNoteDescCalendar() {
    this.setState({
      flagNoteDescCalendar: true
    })
  }

  render() {
    let recipients = rxaget(this.state.detail, 'recipients', []).filter(u => !u.owner)
    return (
      <>
        <div className="zchat_popup_calendar_mainbox">
          <div className="zchat_popup_calendar_detail_header">
            <div className="zchat_popup_calendar_title">{translate('Event details')}</div>
            <div className="zchat_popup_calendar_btn_icon_left" onClick={e => this.props.backFunc()}>
              <img className="btn-back-calendar" alt="" src="./images/default/icons/icon-close.svg" />
            </div>
            {this.state.flagAuthOwner && <div className="zchat_popup_calendar_btn_icon_right" onClick={e => this.showPopupOptionCalendar()}>
              <img className="btn-back-calendar" alt="" src="./images/default/icons/icon-more.svg" />
            </div>}
          </div>
          
          <div className="zchat_popup_calendar_body">
            <div className="calendar-container">
              <div className="calendar-box">

                <div className="row-calendar-textheader-maininput">
                  <div className="row-calendar-textheader-title">
                    {rxaget(this.state.detail, 'title', '')}
                  </div>
                  <div className="row-calendar-textheader-creator">
                    <span className='row-calendar-textheader-color'>{translate('Created By')}</span> {rxaget(this.userOwner, 'full_name', '') || rxaget(this.userOwner, 'username', '')}
                  </div>
                </div>
                <div className="row-calendar-detail-line"></div>

                <div className="row-calendar-detail-maininput">
                  <div className="row-calendar-icon">
                    <img src="./images/default/icons/icon-location.svg" alt="" />
                  </div>
                  
                  <div className="row-calendar-detail-contain">
                    <div className="row-calendar-text-left">
                      {translate('Location')}
                    </div>
                  </div>
                </div>

                <div className="row-calendar-detailtime-maininput">
                  <div className="row-calendar-detailtime-text-left">
                  {rxaget(this.state.detail, 'location.name', '')} - {rxaget(this.state.detail, 'location.address', '')}
                  </div>                  
                </div>
                <div className="row-calendar-detail-line"></div>

                <div className="row-calendar-detail-maininput">
                  <div className="row-calendar-icon">
                    <img src="./images/default/icons/icon-calendar.svg" alt="" />
                  </div>
                  
                  <div className="row-calendar-detail-contain">
                    <div className="row-calendar-text-left">
                      {translate('Event Category')}
                    </div>
                  </div>
                </div>

                <div className="row-calendar-detailtime-maininput">
                  <div className="row-calendar-detailtime-text-left">
                  {rxaget(this.state.detail, 'category.name', '')} {rxaget(this.state.detail, 'category.source', '')}
                  </div>                  
                </div>
                <div className="row-calendar-detail-line"></div>

                <div className="row-calendar-detail-maininput">
                  <div className="row-calendar-icon">
                    <img src="./images/default/icons/icon-recent.svg" alt="" />
                  </div>
                  
                  <div className="row-calendar-detail-contain">
                    <div className="row-calendar-text-left">
                      {translate('Time')}
                    </div>
                  </div>
                </div>

                <div className="row-calendar-detailtime-maininput">
                  <div className="row-calendar-detailtime-text-left">
                    {translate('From')} {convertUnixToDateTime(rxaget(this.state.detail, 'time_start', ''), 'custom', this.language)}
                  </div>
                  
                </div>

                <div className="row-calendar-detailtime-maininput">
                  <div className="row-calendar-detailtime-text-left">
                    {translate('To')} {convertUnixToDateTime(rxaget(this.state.detail, 'time_end', ''), 'custom', this.language)}
                  </div>
                </div>

                <div className="row-calendar-detail-line"></div>


                <div className="row-calendar-detail-maininput">
                  <div className="row-calendar-detail-icon-user">
                    <img src="./images/default/icons/icon-user-invite.svg" alt="" />
                  </div>
                  
                  <div className="row-calendar-detail-contain" onClick={e => this.showRecipients()}>
                    <div className="row-calendar-text-left">
                      {translate('Participants')}
                    </div>
                    {recipients.length > 0 && <div className="row-calendar-text-right">
                      {recipients.length}
                      <img src="./images/default/icons/icon-dropnext.svg" alt=""/>
                    </div>}
                  </div>
                </div>

                {/* <div className="row-calendar-detailtime-recipients">
                {(rxaget(this.state.detail, 'recipients', []) && rxaget(this.state.detail, 'recipients', []).length > 0) && <div className='calendar-list-member'>
                  {rxaget(this.state.detail, 'recipients', []).map((user, index) => <div key={index}>
                    <div className="row-calendar-info-maininput">
                      <div className="ava-joiner-box">
                        <span className='ava-joiner-span' style={{ background: `${changeColorAva(rxaget(user, 'Id', '').length)}` }}>{textAva(rxChangeSlug(rxaget(user, 'full_name', ''))) || textAva(rxaget(user, 'phone', '')) }</span>
                      </div>
                      
                      <div className="fullname-joiner-text">
                        {rxaget(user, 'full_name', '') || rxaget(user, 'phone', '')}
                      </div>                  
                    </div>
                    <div className="row-calendar-detail-line"></div>
                  </div>)}
                </div>}                  
                </div>
                 */}
                <div className="row-calendar-detail-line"></div>
                
                

                <div className="row-calendar-detail-maininput">
                  <div className="row-calendar-icon">
                    <img src="./images/default/icons/icon-quick-message.svg" alt="" />
                  </div>
                  
                  <div className="row-calendar-detail-contain">
                    <div className="row-calendar-text-left">
                      {translate('Note')}
                    </div>
                  </div>
                </div>

                <div className="row-calendar-detailnote-maininput">
                  <div className="row-calendar-detailtime-text-left" onClick={e => this.showPopupNoteDescCalendar()}>
                    {rxaget(this.state.detail, 'short_description', '').trim()}
                  </div>                  
                </div>
                <div className="row-calendar-detail-line"></div>


                


                <div className="row-calendar-detail-maininput">
                  <div className="row-calendar-icon">
                    <img src="./images/default/icons/icon-reminder.svg" alt="" />
                  </div>
                  
                  <div className="row-calendar-detail-contain">
                    <div className="row-calendar-text-left">
                      {translate('Reminder')}
                    </div>
                  </div>
                  <div className="row-calendar-detail-remind-right">
                    {(rxaget(this.state.detail, 'remind_time', '')) && <span>{rxaget(this.state.detail, 'remind_time', '')}</span>}
                  </div>
                </div>

                <div className="row-calendar-detail-line"></div>

                

                {/* <div className="row-calendar-detail-maininput">
                  <div className="row-calendar-icon">
                    <img src="./images/default/icons/icon-reminder.svg" alt="" />
                  </div>
                  
                  <div className="row-calendar-detail-contain">
                    <div className="row-calendar-text-left">
                      Kênh nhắc
                    </div>
                  </div>
                </div>

                <div className="row-calendar-detailtime-maininput">
                  <div className="row-calendar-detailtime-text-left">
                    {rxaget(this.state.detail, 'remind_channel', '')}
                  </div>                  
                </div>
                <div className="row-calendar-detail-line"></div> */}

              </div>
            </div>
          </div>
        </div>

        {this.state.flagPopupOptionCalendar && <>
          <div className="zchat_choose_calendar-bg" onClick={e => this.handleClickOutside(e)}></div>
          <div className="zchat_choose_typecalendar-box">
            <div className="zchat_choose_typecalendar-header">
              {translate('Option')}
            </div>
            <div className="zchat_choose_typecalendar-row" onClick={e => this.chooseOptionCalendar('edit')}>
              {translate('Edit event ')}
            </div>
            <div className="zchat_choose_typecalendar-row btn-delete-calendar" onClick={e => this.chooseOptionCalendar('delete')}>
              {translate('Delete event')}
            </div>            
          </div>
        </>}

        {this.state.flagPopupConfirm && <>
          <div className="zchat_choose_calendar-bg" onClick={e => this.handleClickOutside(e)}></div>
          <div className="zchat_confirmcalendar-box">
            <div className="zchat_confirm-calendar-header">
              {translate('Delete event')}
            </div>
            <div className="zchat_confirm-calendar-desc">
              <span>
                {translate('Do you want to delete this event')}
              </span>
            </div>
            
            <div className="zchat_choose_notecalendar-button">
              <div className="zchat_notecalendar-btn-cancel" onClick={e => this.cancelDescConfirm()}>
                {translate('Cancel')}
              </div>

              <div className="zchat_notecalendar-btn-save"  onClick={e => this.confirmDelete()}>
                {translate('Delete')}
              </div>
            </div>
          </div>
        </>}

        {this.state.flagShowRecipients && <>
          <div className="zchat_choose_calendar-bg" onClick={e => this.handleClickOutside(e)}></div>
          <div className="zchat_choose_reminder-box">
            <div className="zchat_choose_reminder-header">
              {translate('Participants')}
            </div>
            {(rxaget(this.state.detail, 'recipients', []) && recipients.length > 0) && <div className='calendar-list-recipients'>
              {recipients.map((user, index) => <div key={index}>
                <div className="row-calendar-info-recipients">
                  <div className="ava-joiner-box">
                    <span className='ava-joiner-span' style={{ background: `${changeColorAva(rxaget(user, 'Id', '').length)}` }}>{textAva(rxChangeSlug(rxaget(user, 'full_name', ''))) || textAva(rxaget(user, 'phone', '')) }</span>
                  </div>
                  
                  <div className="fullname-joiner-text">
                    {(rxaget(user, 'full_name', '')) ? rxaget(user, 'full_name', '') : rxaget(user, 'phone', '') || rxaget(user, 'username', '')}
                  </div>                  
                </div>
                <div className="row-calendar-detail-line"></div>
              </div>)}
            </div>}
          </div>
        </>}

        {this.state.flagNoteDescCalendar && <>
          <div className="zchat_choose_calendar-bg" onClick={e => this.handleClickOutside(e)}></div>
          <div className="zchat_notecalendar-box">
            <div className="zchat_notecalendar-header">
              {translate('Note')}
            </div>
            <div className="zchat_popup_calendar_btn_icon_right" onClick={e => this.handleClickOutside(e)}>
              <img className="zchat_notecalendar-btn-close" alt="" src="./images/default/icons/icon-close.svg" />
            </div>
            <div className="zchat_notecalendar-desc-body">
              <input type="text" autoComplete="off" maxLength="255" className="zchat_notecalendar-input-shortdesc" defaultValue={rxaget(this.state.detail, 'short_description', '')} readOnly={true}/>
            </div>
            <div className="zchat_notecalendar-desc-body">
              <textarea type="text" autoComplete="off" placeholder={translate('Description')} maxLength="2000" className="zchat_notecalendar-input-longdesc" defaultValue={rxaget(this.state.detail, 'full_description', '')} readOnly={true}/>
            </div>
          </div>
        </>}

      </>      
    )
  }
}

export default DetailCalendar;